<template>
    <div class="link-word-modal">
        <TitleBaseBox :title="title" @close="close" @confirm="confirmClick">
            <div class="link-word-content">
                <div class="link-word-name">
                    <div class="link-word-text">{{ wordLabel }}</div>
                    <div class="link-word-show">{{ word }}</div>
                </div>
                <div class="link-word-name">
                    <div class="link-word-text">{{ linkTypeLabel }}</div>
                    <div class="link-radio-choose">
                        <RadioGroup :space="106" :radios="linkTypeSettings" @change="radioChange" />
                        <span v-if="false" class="link-color inner-color" :style="{ background: data.colorData.innerColor }"></span>
                        <span v-if="false" class="link-color out-color" :style="{ background: data.colorData.outColor }"></span>
                    </div>
                </div>
                <div class="link-word-name">
                    <div class="link-word-text">{{ linkLabel }}</div>
                    <ValidateInput
                        class="link-word-input"
                        :placeholder="inputLinkLabel"
                        :initValue="url"
                        :hasRadius="true"
                        @inputChange="urlChange"
                    />
                </div>
                <div class="link-word-delete" v-show="data.type === 'update'" @click="deleteLink">
                    <Icon :width="16" :height="18" bgPosition="-96px 0" hoverBgPosition="-96px -22px" class="link-delete-icon" />
                    {{ deleteLabel }}
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import ValidateInput from "@/views/zhiji/bComponents/inputs/ValidateInput";
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import RadioGroup from "@/views/zhiji/bComponents/checks/RadioGroup";

export default {
    name: "LinkWordModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        ValidateInput,
        Icon,
        RadioGroup
    },
    data() {
        return {
            word: this.data.word || "",
            url: this.data.url || "",
            urlType: "innerColor",
            linkTypeRadios: [
                {
                    label: this.$t("zhiji.knowlege.linkWordModal.innerLink"),
                    value: "innerColor",
                    checked: true
                },
                {
                    label: this.$t("zhiji.knowlege.linkWordModal.outerLink"),
                    value: "outColor",
                    checked: false
                }
            ]
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.knowlege.linkWordModal.title");
        },
        wordLabel() {
            return this.$t("zhiji.knowlege.linkWordModal.wordLabel");
        },
        linkTypeLabel() {
            return this.$t("zhiji.knowlege.linkWordModal.linkTypeLabel");
        },
        linkLabel() {
            return this.$t("zhiji.knowlege.linkWordModal.linkLabel");
        },
        deleteLabel() {
            return this.$t("zhiji.knowlege.linkWordModal.deleteLabel");
        },
        inputWordLabel() {
            return this.$t("zhiji.knowlege.linkWordModal.inputWordLabel");
        },
        inputLinkLabel() {
            return this.$t("zhiji.knowlege.linkWordModal.inputLinkLabel");
        },
        linkTypeSettings() {
            let colorType = this.data.colorType;

            if (colorType == "innerColor") {
                this.setCheckedLink("innerColor");
            } else {
                this.setCheckedLink("outColor");
            }

            return this.linkTypeRadios;
        }
    },
    methods: {
        close() {
            this.data.cancel && this.data.cancel({});
            this.$emit("closeModal");
        },
        wordChange(newVal) {
            this.word = newVal;
        },
        urlChange(newVal) {
            this.url = newVal;
        },
        setCheckedLink(linkType) {
            let innerColor = this.linkTypeRadios[0];
            let outColor = this.linkTypeRadios[1];

            innerColor.checked = false;
            outColor.checked = false;

            linkType == "outColor"
                ? this.linkTypeRadios.splice(1, 1, Object.assign({}, outColor, { checked: true }))
                : this.linkTypeRadios.splice(0, 1, Object.assign({}, innerColor, { checked: true }));
        },
        getUrlTtype() {
            for (let type in this.data.colorData) {
                if (type === this.urlType) {
                    return {
                        colorType: type,
                        color: this.data.colorData[type]
                    };
                }
            }
        },
        confirmClick() {
            if (!this.url) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: this.$t("zhiji.knowlege.linkWordModal.linkTip")
                    }
                });
            } else {
                this.data.confirm &&
                    this.data.confirm({
                        id: this.data.id || "",
                        type: this.data.type,
                        urlType: this.getUrlTtype(),
                        url: this.url,
                        word: this.word
                    });

                this.$emit("closeModal");
            }
        },
        deleteLink() {
            this.data.confirm &&
                this.data.confirm({
                    id: this.data.id || "",
                    type: "delete",
                    url: this.url,
                    urlType: this.getUrlTtype(),
                    word: this.word
                });

            this.$emit("closeModal");
        },
        radioChange(data) {
            this.urlType = data;
        }
    }
};
</script>

<style scoped lang="scss">
.link-word-modal {
    width: 100%;
    height: 100%;
    background-color: rgba(18, 22, 37, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    .link-word-content {
        width: 352px;
    }

    .link-word-name {
        margin-bottom: 20px;
    }

    .link-word-text {
        font-size: 16px;
        margin-bottom: 4px;
    }

    .link-radio-choose {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 12px;

        .link-color {
            background: red;
            display: inline-block;
            width: 64px;
            height: 32px;
            position: relative;
        }

        .out-color {
            left: -54px;
        }

        .inner-color {
            left: -154px;
        }
    }

    .link-word-show {
        min-height: 32px;
        max-height: 108px;
        background: #f2f7fb;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        padding: 6px 8px 5px;
        box-sizing: border-box;
        overflow-y: auto;
    }

    .link-word-input {
        display: inline-block;
        width: 100%;
        border: 0;
    }

    .link-word-delete {
        position: absolute;
        bottom: 30px;
        cursor: pointer;
        text-decoration: underline;

        .link-delete-icon {
            vertical-align: -3px;
        }

        &:hover {
            color: #2ec2ff;
            .link-delete-icon {
                background-position: -96px -22px !important;
            }
        }
    }
}
</style>
